export const TERMS_MODAL_STYLES = `
<style>
	body {
		padding: 36px;
		margin: 0;
		font-family: Noto Sans JP, ヒラギノ角ゴ Pro W3, メイリオ, sans-serif;
	}
	h1 {
		font-size: 20px;
		font-weight: bold;
		text-align: center;
		margin-bottom: 20px;
		text-decoration: underline;
	}
	h2 {
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 15px;
		margin-top: 20px;
		text-align: center;
	}
	h3 {
		font-size: 16px;
		font-weight: bold;
		text-decoration: underline;
		margin-bottom: 8px;
		margin-top: 15px;
	}
	p {
		margin-bottom: 10px;
		line-height: 22px;
		text-align: justify;
	}
	li {
		margin-bottom: 8px;
		line-height: 20px;
		text-align: justify;
	}
	ul {
		list-style-type: none;
	}
	ol {
		padding-left: 20px;
	}
	a {
		text-decoration: underline;
	}
</style>
`;
